/**
 * Created by Andrey Popov on 01.10.2026
 *
 * A classic expedition (heroes, fruits, wands) described by its design folder (see expeditiondesign.js).
 */

const ClassicExpedition = {
    SHOP_TAB: 28,

    // what the last classic expeditions share, the expedition's config.json overrides any of it
    DESIGN: {
        landmark: {
            fog: "fog3",
            force: "LANDMARK_DONOR_SLOT1",
            donors: ["rpcustomermain0", "rpcustomermain1", "rpcustomermain2", "rpcustomermain3"]
        },

        library: [
            ["drhero", "drrubyhero"],
            ["drresource"],
            ["drfruit"],
            ["drgrowing", "drsource"],
            ["drchest"],
            ["drmagicplant", "snailfeast", "snailhouse"]
        ],
        libraryPrefix: "dr",

        pixels: {
            fog: "fog3",
            reward: [{
                units: [
                    { code: "drmagicplant", stage: 0 },
                    { code: "worker", stage: 0 },
                    { code: "drfruit", stage: 0 }
                ]
            }],
            collect: {
                x: { align: "center", dx: 10 },
                y: { align: "center", dy: -45 },
                delay: 150
            }
        },

        rewards: {
            Pack: [
                { hard: 350, unit: [{ code: "dr2dragonpack", stage: 0, amount: 1 }] },
                { hard: 1200, unit: [{ code: "dr2dragonpack", stage: 0, amount: 1 }] },
                { hard: 1200, unit: [{ code: "dr2dragonpack", stage: 0, amount: 1 }] },
                { hard: 6500, unit: [{ code: "dr2dragonpack", stage: 0, amount: 1 }] },
                { hard: 6500, unit: [{ code: "dr2dragonpack", stage: 0, amount: 1 }] }
            ],
            LineOffer: [
                { hard: 50, energy: 50, unit: [{ code: "drfruit", stage: 4, amount: 3 }] },
                { hard: 100, energy: 150, unit: [{ code: "drfruit", stage: 4, amount: 5 }] },
                { hard: 100, energy: 150, unit: [{ code: "drfruit", stage: 4, amount: 5 }] },
                { hard: 350, energy: 450, unit: [{ code: "drfruit", stage: 4, amount: 10 }] },
                { hard: 350, energy: 450, unit: [{ code: "drfruit", stage: 4, amount: 10 }] }
            ],
            HeroOffer: [
                { energy: 100, unit: [{ code: "drshopchest", stage: 2, amount: 1 }] },
                { energy: 350, unit: [{ code: "drshopchest", stage: 2, amount: 2 }] },
                { energy: 350, unit: [{ code: "drshopchest", stage: 2, amount: 2 }] },
                { energy: 2000, unit: [{ code: "drshopchest", stage: 2, amount: 8 }] },
                { energy: 2000, unit: [{ code: "drshopchest", stage: 2, amount: 8 }] }
            ]
        }
    },

    register: function (design) {
        const id = design.id;
        const settings = cleverapps.override(cleverapps.clone(this.DESIGN, true), design);

        CustomerRecipes[id] = cleverapps.clone(CustomerRecipes.universal, true);

        Ruins.TIERS[id] = cleverapps.clone(Ruins.TIERS.universal, true);

        MissionTree.PRIZES[id] = [];

        AchievementsConfig.registerExpedition(id, { ...settings.landmark, force: Forces[settings.landmark.force] });

        cleverapps.styles[id] = {
            fogAsColorForUnits: {
                color: new cc.Color(0, 150, 255, 255),
                opacity: 120
            },
            expeditionWandsGuideWindow: this.createWandsGuideStyles()
        };

        UnitsLibrary.CODES_BY_TAB[id] = settings.library;
        UnitsLibrary.EXPEDITION_PREFIXES[id] = settings.libraryPrefix;

        cleverapps.styles.FogTileView[id] = cleverapps.styles.FogTileView.adventure;

        cleverapps.SkinManager.SKINS[`${id}_expedition`] = this.createSkin(id);

        Object.keys(settings.rewards).forEach((name) => {
            RewardsConfig[id.charAt(0).toUpperCase() + id.slice(1) + name] = settings.rewards[name];
        });

        this.registerShop(id);
        this.registerPixels(id, settings.pixels);

        Map2dLocation.TUTORIALS.push(this.createTutorial.bind(this, id));
    },

    registerShop: function (id) {
        const tab = ShopWindow.TABS[`UNITS_EXPEDITION_${id.toUpperCase()}`] = this.SHOP_TAB;

        UnitsShop.SHOPS[id] = [{
            tab,
            unit: { code: "dr2shop", stage: 0 }
        }];

        UnitsShop.PRODUCTS[tab] = {
            refreshTimeout: "24 hours",
            refreshPrice: 199,

            default: [{
                unit: {
                    code: "drfreechest",
                    stage: 0,
                    amount: 1
                },
                type: Product.TYPE_FREE,
                left: 1
            }, {
                unit: {
                    code: "drsack",
                    stage: 0,
                    amount: 2
                },
                type: Product.TYPE_FREE,
                left: 1
            }, {
                unit: {
                    code: "drsack",
                    stage: 2,
                    amount: 1
                },
                price: 149,
                type: Product.TYPE_HARD,
                left: 3
            }, {
                unit: {
                    code: "drshopchest",
                    stage: 0,
                    amount: 1
                },
                price: 49,
                type: Product.TYPE_HARD,
                left: 10
            }, {
                unit: {
                    code: "drshopchest",
                    stage: 1,
                    amount: 1
                },
                price: 129,
                type: Product.TYPE_HARD,
                left: 15
            }, {
                unit: {
                    code: "drshopchest",
                    stage: 2,
                    amount: 1
                },
                price: 319,
                type: Product.TYPE_HARD,
                left: 30
            }, {
                unit: {
                    code: "crystal",
                    stage: 3,
                    amount: 1
                },
                price: 119,
                type: Product.TYPE_HARD,
                left: 5
            }, {
                unit: {
                    code: "worker",
                    stage: 4,
                    amount: 1
                },
                price: 79,
                type: Product.TYPE_HARD,
                left: 5
            }],

            line_template: [{
                unit: {
                    stage: 0,
                    amount: 1
                },
                codes: "field",
                left: 1,
                price: 199,
                type: Product.TYPE_HARD
            }]
        };
    },

    registerPixels: function (id, pixels) {
        PixelsPlanner.AVAILABLE[id] = {
            fog: pixels.fog
        };

        PixelsSwarm[id.toUpperCase()] = id;

        PixelsSwarmConfig[id] = {
            pages: [id],
            reward: pixels.reward
        };

        cleverapps.styles.PixelView[id] = cleverapps.overrideStyles(cleverapps.styles.PixelViewTemplate, {
            collect: pixels.collect
        }, true);
    },

    createWandsGuideStyles: function () {
        const container = {
            x: { align: "center" },
            y: { align: "center", dy: -80 }
        };

        const styles = cleverapps.clone(cleverapps.styles.ExpeditionWandsGuideWindow, true);
        styles.firstStage.container = cleverapps.clone(container, true);
        styles.thirdStage.container = cleverapps.clone(container, true);
        styles.secondStage = {
            container,

            ground: {
                x: 0,
                y: 0
            },

            prizeview: {
                x: { align: "center" },
                y: { align: "top", anchor: 0, dy: 80 }
            },

            hero: {
                x: 205,
                y: 190,
                scale: 1.1
            },

            finger: {
                x: 305,
                y: 33
            }
        };
        return styles;
    },

    createSkin: function (id) {
        return {
            bundle: `expedition_${id}`,

            slots: {
                ...cleverapps.SkinManager.SKINS.rose_energy.slots,

                gameAudio: function () {
                    return bundles[`expedition_${id}`].urls[`${id}_music`];
                },

                unitOnCell: function () {
                    return cleverapps.styles.UnitOnCellExpedition;
                },

                gameSceneBg: function () {
                    return {};
                },

                showOneIngredientLeft: function () {
                    return true;
                },

                fogAsColorForUnits: function () {
                    return cleverapps.styles[id].fogAsColorForUnits;
                },

                customerInfoViewFont: function () {
                    return cleverapps.styles.FONTS.EXPEDITION_CUSTOMER_INGREDIENT_INFOVIEW;
                },

                ruinsWindow: function () {
                    return {
                        bundle: `ruinswindow_${id}`,
                        dictionaryKey: `RuinsWindow.${id}.`,
                        person: {
                            role: "elf"
                        }
                    };
                },

                CustomerInfoViewIconScale: function () {
                    return 1;
                },

                fogBlocker: function () {
                    return cleverapps.styles.FogLockView.expedition;
                },

                feed_icon_png: bundles[`merge_${id}`].frames[`${id}_feed_icon_png`],
                wand_icon_png: bundles[`merge_${id}`].frames[`${id}_wand_icon_png`],

                whirlwind: bundles.fog_animations.jsons[`${id}_whirlwind`],

                merge_wand_png: bundles.menubar.frames[`${id}_merge_wand_png`],

                expedition_buildpass_icon_json: bundles.sidebar.jsons[`${id}_expedition_buildpass_icon_json`],

                reward_wand_png: bundles[`reward_icons_merge_${id}`].frames[`${id}_reward_wand_png`],
                reward_wand_small_png: bundles[`reward_icons_merge_${id}`].frames[`${id}_reward_wand_small_png`],

                snail_feast_icon_json: bundles.sidebar.jsons[`${id}_snail_feast_icon_json`],
                snailhouse_offer_json: bundles.sidebar.jsons[`${id}_snailhouse_offer_json`],
                snailhouse_offer_extrabar_icon: bundles.extrabar && bundles.extrabar.jsons[`${id}_snailhouse_offer_extrabar_icon`],
                snail_feast_icon: bundles[`reward_icons_merge_${id}`].frames[`${id}_snail_feast_icon`],

                pass_star_png: bundles.reward_icons_pass.frames[`${id}_pass_star_png`],

                fog_disappear_effect: function () {
                    return bundles[`fog_${id}`].urls.open_effect;
                },
                unitGroundHighlight: function () {
                    return false;
                },
                expeditionWandsGuideWindowStyles: function () {
                    return cleverapps.styles[id].expeditionWandsGuideWindow;
                }
            }
        };
    },

    createTutorial: function (id) {
        return new TutorialScenario(`${id}_tutorial`, {
            manual: true,
            isAvailable: () => Map2dLocation.currentLocation && Map2dLocation.currentLocation.map.fogs.blocks.fog1,
            listSteps: () => [
                MergeTutorialHelper.createUnlockFogStep({ id: "fog0" }),
                MergeTutorialHelper.createAdviceStep({
                    type: Map2d.MERGE,
                    targets: { code: "dr2dragonblue", stage: 0 },
                    person: "dwarf",
                    text: `Tutorial.${id}.step1`,
                    arrowDelay: 0.2
                }),
                MergeTutorialHelper.createAdviceStep({
                    type: Map2d.MERGE,
                    targets: { code: "drfruit", stage: 0 },
                    person: "dwarf",
                    text: `Tutorial.${id}.step2`,
                    arrowDelay: 0.2
                }),
                MergeTutorialHelper.createAdviceStep({
                    type: Map2d.MERGE,
                    targets: { code: "drfruit", stage: 1 },
                    arrowDelay: 0.2
                }),
                MergeTutorialHelper.createAdviceStep({
                    type: Map2d.MERGE,
                    targets: { code: "drfruit", stage: 2 },
                    arrowDelay: 0.2
                }),
                MergeTutorialHelper.createAdviceStep({
                    type: Map2d.SPAWN,
                    targets: { code: "drfruit", stage: 3 },
                    prizes: { code: "drfruit", stage: 4 },
                    person: "dwarf",
                    text: `Tutorial.${id}.step3`,
                    arrowDelay: 0.2
                }),
                MergeTutorialHelper.createAdviceStep({
                    type: Map2d.FEED_HERO,
                    targets: { code: "drfruit", stage: 4 },
                    person: "dwarf",
                    text: `Tutorial.${id}.step4`,
                    arrowDelay: 0.2,
                    fingerDelay: 0.1,
                    nextStepDelay: 2,
                    scroll: {
                        visibleBox: {
                            left: 0.3, right: 0.4, top: 0.0, bottom: 0.15
                        }
                    }
                }),
                this.createOpenFogStep({ fog: "fog1", person: "dwarf", text: `Tutorial.${id}.step5` })
            ]
        });
    },

    createOpenFogStep: function (data) {
        return new TutorialStep({
            onStart: function () {
                this.type = Map2d.OPENFOG;
                this.targets = [data.fog];

                Map2dLocation.currentLocation.map.fogs.calcFogStates();
                Map2d.currentMap.advice.setLogic(Map2d.OPENFOG, { targets: this.targets });

                if (!Map2d.currentMap.advice.hasHints()) {
                    this.finish();
                    return;
                }

                const move = Map2d.currentMap.advice.findMove();

                if (!move) {
                    this.finish();
                    return;
                }

                cleverapps.focusManager.compound(this.finish.bind(this), [
                    function (f) {
                        MergeTutorialHelper.scrollToTarget(move.mergeCluster || [move.cells[0]], f);
                    },

                    function (f) {
                        cleverapps.focusManager.setEventNodes([cleverapps.Scenes.GetRunningScene()]);
                        const visibleControls = ["map2d"];
                        const hiddenControls = cleverapps.focusManager.controls.filter((control) => visibleControls.indexOf(control) === -1);

                        cleverapps.focusManager.hideControlsWhileFocused(hiddenControls);
                        cleverapps.focusManager.showControlsWhileFocused(visibleControls);
                        Map2d.currentMap.advice.startHint({
                            arrow: { delay: MergeTutorial.ARROW_DELAY },
                            finger: {
                                delay: MergeTutorial.FINGER_DELAY,
                                repeatDelay: 2
                            }
                        });

                        this.dialogue = MergeTutorialHelper.createMinimalDialogue({
                            person: data.person,
                            text: data.text
                        });

                        cleverapps.tutorial.on(Map2d.OPENFOG, f);
                    }.bind(this)
                ]);
            },

            onFinish: function () {
                Map2d.currentMap.advice.stopHint();
                this.dialogue && this.dialogue.remove();

                Map2dLocation.currentLocation.counter.trigger();
            }
        });
    }
};

ExpeditionDesign.list().filter((design) => design.type === "classic").forEach(ClassicExpedition.register, ClassicExpedition);
